import { TOGGLE } from '@/store/actions/edit_ride/options';

export const initialState = {
    avoidHighways: false,
    avoidTolls: false,
    avoidFerries: false,
    avoidTunnels: false,
    avoidUnpavedRoads: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE:
            //eslint-disable-next-line
            const { feature } = action.data;
            return {
                ...state,
                [feature]: !state[feature]
            };

        default:
            return state;
    }
};
